/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-23 16:37:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-04 10:35:44
 * @FilePath: /src/app/payment/components/ShippingAddressAndMethod/index.tsx
 * @Description: 已选择的地址信息 & 物流信息
 */
'use client';

import { IPrice } from '@/api/types/order';
import { Address } from '@/api/types/public';
import Image from '@/components/Image';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { isEmpty } from '@/utils/tools';
import { useTranslations } from 'next-intl';

interface ShippingAddressAndMethodProps {
  address: Address;
  method: any;
  freightList: IPrice['freight'];
  onEdit: () => void;
}

export default function ShippingAddressAndMethod({
  address,
  method,
  freightList,
  onEdit,
}: ShippingAddressAndMethodProps) {
  const globalT = useTranslations('');
  const t = useTranslations('payment.ShippingAddressAndMethod');
  // 使用zustand获取货币信息
  const currency = useStore((state) => state.currency);

  const freeThresholdHandler = (priceInfo: any[]) => {
    if (!isEmpty(priceInfo)) {
      const currentPrice = priceInfo.find((item) => item.currency === currency.name);
      return currentPrice?.price || '';
    }
    return '';
  };

  if (!method) {
    return null;
  }

  return (
    <div className="flex relative">
      {/* 收货地址 */}
      <div className="w-[48%] mr-12 break-words">
        <h3 className="mb-3 text-[18px] font-bb">{t('ShippingAddress')}</h3>
        <p className="text-base leading-tight">{address.address}</p>
        <div className="mt-16">
          <span className="text-sm mr-20">
            {address.firstname} {address.lastname}
          </span>
          <span className="text-sm">{address.telephone}</span>
        </div>
      </div>

      {/* 配送方式 */}
      <div className="w-[40%]">
        <h3 className="mb-3 text-[18px] font-bb">{t('ShippingMethod')}</h3>
        {freightList.map(
          (item, index) =>
            method.name === item.name && (
              <p key={index} className="text-base">
                {item.name === 'ordinary' &&
                  `${t('ordinary')} (${item.time_min}-${item.time_max} ${globalT('payment.ShippingMethod.days')})`}
                {item.name === 'advanced' &&
                  `${t('advanced')} (${item.time_min}-${item.time_max} ${globalT('payment.ShippingMethod.days')})`}
                {item.name === 'business' &&
                  `${t('business')} (${item.time_min}-${item.time_max}  ${globalT('payment.ShippingMethod.days')})`}
              </p>
            ),
        )}

        {/* 显示运费标签 */}
        {method?.freight_discount_type === 2 && (
          <span className="inline-block h-[18px] rounded-[4px] text-xs text-white px-[6px] whitespace-nowrap box-border bg-[#FFB801]">
            {globalT('payment.ShippingMethod.over')}{' '}
            <span className="">
              {formatPriceNumberWithSymbol(
                freeThresholdHandler(method.free_threshold_price_info),
                currency,
              )}
            </span>{' '}
            {globalT('payment.ShippingMethod.free')}
          </span>
        )}

        {method?.freight_discount_type === 3 && method?.name === 'business' && (
          <Image
            src="/payment/zing_icon@2x.png"
            alt="zeelool glasses"
            width={92}
            height={24}
            className="mt-2"
          />
        )}

        {method.freight_discount_type === 4 && (
          <div className="inline-block h-[18px] rounded-[4px] text-xs  text-white px-[6px] whitespace-nowrap box-border bg-[#00C191]">
            {t('shippingCoupon')}
          </div>
        )}
      </div>

      {/* 编辑按钮 */}
      <Image
        src="/payment/edit@2x.png"
        alt="edit"
        width={18}
        height={18}
        className="absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer"
        onClick={onEdit}
      />
    </div>
  );
}
